export default {
  // 设备仓库的searchList
  commonSearchList: {
    terminalModel: '设备类型',
    terminalStatus: '设备状态',
    searchKeyword: '关键字查询'
  },
  commonBtnList: {
    refresh: '刷新',
    clear: '清空'
  },
  commonTableBtns: {
    enable: '启用'
  },
  commonTableBtnsMore: {
    putIn: '入仓',
    repair: '维修',
    scrap: '报废',
    set: '设置',
    test: '招测',
    info: '详情'
  },
  // 公共的表格表头
  commonTableHeader: {
    onLineName: '在线/离线',
    equipmentProvider: '厂商代码',
    statusName: '设备状态',
    sortId: '设备序号',
    terminalName: '设备名称',
    terminalModel: '设备型号',
    terminalSn: '设备序列号',
    terminalImsi: '设备IMSI卡号',
    areaInfo: '所在区域',
    terminalAddr: '安装地点'
  }
};